import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Divider,
  Avatar,
  Box,
  ToggleButtonGroup,
  Chip,
  ToggleButton,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  Bolt,
  Smartphone,
  Close as CloseIcon,
  Save as SaveIcon,
  Close,
  Save,
  DesktopWindows,
  PhoneIphone,
  ContentCopy,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import {
  createServiceCommunicationThunk,
  updateServiceCommunicationThunk,
} from "../../../../store/slices/CommunicationServiceSlice";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const { toast } = require("react-toastify");

const PhoneFrame = ({ children }) => (
  <Box
    sx={{
      width: { xs: 260, sm: 280 },
      height: { xs: 520, sm: 560 },
      bgcolor: "#f7f7fa",
      borderRadius: "36px",
      border: "10px solid #0d0d12",
      position: "relative",
      boxShadow: 4,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      mx: "auto",
    }}
  >
    <Box sx={{ height: 36, bgcolor: "#f7f7fa" }}>
      <Box
        sx={{
          width: 120,
          height: 22,
          bgcolor: "#dcdce3",
          borderRadius: "12px",
          mx: "auto",
          mt: 1.2,
        }}
      />
    </Box>
    <Box sx={{ flex: 1, overflowY: "auto" }}>{children}</Box>
    <Box
      sx={{
        p: 1.2,
        bgcolor: "#fff",
        borderTop: "1px solid #eee",
        display: "flex",
        gap: 1,
      }}
    >
      <TextField size="small" fullWidth placeholder="Message" />
      <Button size="small" variant="contained" sx={{ minWidth: 32, px: 0.75 }}>
        +
      </Button>
    </Box>
  </Box>
);

export default PhoneFrame;
